import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import { Col, Button } from 'react-bootstrap5';

import routes from 'app/routes';
import PermissionsGate from 'components/Users/PermissionsGate';
import Card from 'components/Managers/Templates/Views/Card/Index';
import { useContext as useTemplatesContext } from 'components/Managers/Templates/Context';
import { useContext as useUsersContext } from 'components/Users/Context';
import Alert from 'components/new_ui/Alerts/alert';
import confirmAlert from 'components/new_ui/Alerts/confirm';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

export default function Template({ template, mainAction }) {
  const { actions: actionsTemplates, dispatch: dispatchTemplates } = useTemplatesContext();
  const [checkLoading, setCheckLoading] = useState(false);

  const navigate = useNavigate();
  const { state: stateUser } = useUsersContext();

  const onEditClick = () => {
    setCheckLoading(true);
    actionsTemplates.show(template.id, (data) => {
      setCheckLoading(false);

      if (data.attributes.possible_update) {
        navigate(
          routes.managers.templates.editChooseTopics(template.id),
          {
            state: {
              template,
            },
          },
        );
      } else {
        Alert({
          title: 'Edit Program',
          text: 'This program is assigned to one or more members of the enterprise, therefore it cannot be updated.',
          confirmButtonText: 'Close',
        });
      }
    });
  };

  const onDeleteClick = () => {
    actionsTemplates.show(template.id, (data) => {
      setCheckLoading(false);

      if (data.attributes.possible_update) {
        confirmAlert({
          title: 'Delete Program',
          text: `Are you sure that you want to delete this program?
                Employees currently enrolled in this program will not be affected,
                but you will not be able to undo a deleted program.`,
          confirmButtonText: 'Delete',
        }, () => {
          actionsTemplates.delete(dispatchTemplates, template.id);
        });
      } else {
        Alert({
          title: 'Delete Program',
          text: 'This program is assigned to one or more members of the enterprise, therefore it cannot be deleted.',
          confirmButtonText: 'Close',
        });
      }
    });
  };

  const onnCloneClick = () => {
    actionsTemplates.clone(dispatchTemplates, template.id);
  };

  const options = [];

  if (mainAction === 'edit') {
    if (template.attributes.type === 'Program') {
      options.push({
        iconClass: 'download-icon',
        title: 'Download',
        onClick: () => {
          window.open(routes.api.managers.programs.download(template.id), '_blank', 'noreferrer');
        },
      });
    }

    if (stateUser.user && stateUser.user.attributes.permissions['Create Programs'] === 'edit'
    && template.attributes.type === 'Program') {
      options.push({
        iconClass: 'clone-icon',
        title: 'Clone',
        onClick: () => {
          onnCloneClick();
        },
      });
    }

    if (stateUser.user && stateUser.user.attributes.permissions['Create Programs'] === 'edit'
    && template.attributes.possible_edit) {
      options.push({
        iconClass: 'trash-icon',
        title: 'Delete',
        onClick: () => {
          onDeleteClick();
        },
      });
    }
  }

  return (
    <Col lg="6" className="mb-4">
      <Card template={template} options={options}>
        <>
          {mainAction === 'assign' && (
            <PermissionsGate scopes={{ 'Assign Programs to Members': ['edit'] }}>
              <Link
                to={routes.managers.programs.assign(template.id)}
                state={{ template }}
                className="btn btn-primary"
              >
                Assign Members
              </Link>
            </PermissionsGate>
          )}

          {mainAction === 'edit' && template.attributes.possible_edit && (
            <PermissionsGate scopes={{ 'Create Programs': ['edit'] }}>
              <Button
                onClick={onEditClick}
                disabled={checkLoading}
              >
                {checkLoading && <LoadingPlaceholder placement="inline" />}
                {' '}
                Edit
              </Button>
            </PermissionsGate>
          )}
        </>
      </Card>
    </Col>
  );
}

Template.propTypes = {
  template: PropTypes.object.isRequired,
  mainAction: PropTypes.string,
};

Template.defaultProps = {
  mainAction: 'assign',
};
